export enum MeetingRoomSortType {
    Id,
    Name,
    IsDeleted
}
